import { decodeImageToDisplayableSrc } from "@lib/media/decode-image"

export async function fileToThumbnail(file: File): Promise<string> {
  const mime = file.type || ""
  const isPdf = mime === "application/pdf" || file.name?.toLowerCase().endsWith(".pdf")
  if (isPdf) {
    return "/assets/pdfIcon.png"
  }

  return new Promise((resolve, reject) => {
    const img = new Image()

    const revokeList: Array<() => void> = []
    const cleanup = () => {
      for (const revoke of revokeList) revoke()
    }

    img.onload = () => {
      try {
        const canvas = document.createElement("canvas")
        const { width, height } = img
        const ratio = height / width
        const newWidth = 150
        const newHeight = Math.round(newWidth * ratio)
        canvas.width = newWidth
        canvas.height = newHeight
        const ctx = canvas.getContext("2d")
        if (ctx) {
          ctx.drawImage(img, 0, 0, newWidth, newHeight)
        }
        cleanup()
        resolve(canvas.toDataURL())
      } catch (e) {
        cleanup()
        reject(e)
      }
    }

    img.onerror = () => {
      cleanup()
      reject(new Error("Could not decode image"))
    }

    async function decodeAndSetImageSrc() {
      try {
        const decoded = await decodeImageToDisplayableSrc({
          file,
          // Safari / iOS sometimes leaves File.type empty for HEIC/TIFF.
          fallbackMimeType: undefined,
        })
        if (decoded.kind === "blob-url") {
          revokeList.push(decoded.revoke)
          img.src = decoded.blobUrl
        } else {
          img.src = decoded.dataUrl
        }
      } catch (e) {
        reject(e)
      }
    }

    decodeAndSetImageSrc()
  })
}
